/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Partner_SubtitleInputs */

const en_business_partner_subtitle = /** @type {(inputs: Business_Partner_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the leading organizations transforming how they consume knowledge.`)
};

const es_business_partner_subtitle = /** @type {(inputs: Business_Partner_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a las organizaciones líderes que transforman cómo consumen conocimiento.`)
};

/**
* | output |
* | --- |
* | "Join the leading organizations transforming how they consume knowledge." |
*
* @param {Business_Partner_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_partner_subtitle = /** @type {((inputs?: Business_Partner_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Partner_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_partner_subtitle(inputs)
	return en_business_partner_subtitle(inputs)
});